import axios from "@/libs/axios";

export default {
    namespaced: true,
    state: {
        batchIds: [],
        show: false,
        loading: false,
        importList: [],
        search: {},
    },
    getters: {
        _batchIds(state) {
            return state.batchIds
        },
        _show(state) {
            return state.show
        },
        _loading(state) {
            return state.loading;
        },
        _importList(state) {
            return state.importList
        },
        _search(state) {
            return state.search
        }
    },
    mutations: {
        addBatchId(state, batchId) {
            state.batchIds.unshift(batchId)
        },
        setImportList(state, importList) {
            state.importList = importList
        },
    },
    actions: {
        getImportList(context) {
            return axios.get('/supplier/product/import', {params: context.state.search})
                .then(res => {
                    if (res.data.success) {
                        context.commit('setImportList', res.data.content.data)
                        const allDone = res.data.content.data.every(
                            item => item.finished_at || item.cancelled_at
                        )
                        if (!allDone) {
                            setTimeout(() => {
                                context.dispatch('getImportList')
                            }, 60000)
                        }
                    }
                })
        },
        uploadFile(context, file) {
            this.loading = true;
            if (!file) {
                alert("Lütfen bir dosya seçiniz.");
                return;
            }
            const formData = new FormData();
            formData.append("excel_file", file);

            axios.post("/supplier/product/import", formData)
                .then(res => {
                    context.commit('addBatchId', res.data.batch_id)
                    alert(res.data.batch_id + ' id işlem başlatıldı')
                    context.dispatch('getImportList')
                })
                .catch(error => {
                    if (error.response && error.response.status === 429) {
                        alert("Çok fazla istek gönderdiniz. Lütfen biraz bekleyin.");
                    } else {
                        alert("Bilinmeyen Bir Hata Oluştu");
                        console.error(error);
                    }
                })
                .finally(() => {
                    this.loading = false;
                })
        }
    }
}